module.exports = __webpack_public_path__ + "img/企业理解.349ffafa.png";